// This file does not require translation
// @utilities
const SECTION_NAME = 'codigos';
const PAGE_NAMES = {
    PROMOTIONS: 'promociones',
    COUPON_CODES: 'codigos'
};
const BUTTON_TAGS = {
    BUY_GIFT_CARD: 'Comprar cheque regalo',
};
 
module.exports = {
    BUTTON_TAGS,
    PAGE_NAMES,
    SECTION_NAME
};